import React from 'react';
import size from 'lodash.size';
import includes from 'lodash.includes';
import { connect } from 'react-redux';
import Loading from '../Common/Loading';
import * as Maps from '../../store/map';
import { Translate } from '../../localization';

function Locations(props) {
    const resetSelectedLocations = (e) => {
        e.preventDefault();
        props.lsportsActions.inplay.resetSelectedLocations();
    };

    const handleClick = (e) => {
        e.preventDefault();
        props.lsportsActions.inplay.selectLocation(e.currentTarget.id);
    };

    let { locations, selectedLocations } = props.lSports.inplay;
    let isAllActive = size(selectedLocations) === 0;

    const locationsList = locations ? (
        locations.map((item, i) => {
            let locationId = item.Id;
            let locationName = item.Name;

            let contains = includes(selectedLocations, locationId + '');

            return (
                <div className="live-box-col" id={locationId} onClick={handleClick} key={locationId}>
                    <div className={`live-box ${contains ? 'active' : ''}`}>
                        {/* <img className="live-flag-25" src={turkeyFlag} /> */}
                        <div country={'flag_' + locationId} className="live-flag-25 flag"></div>
                        <span className="pl-1">{locationName.substring(0, 3)}</span>
                    </div>
                </div>
            );
        })
    ) : (
        <Loading />
    );

    return (
        <div>
            <div className="live-box-row mt-2 mb-2">
                <div className="live-box-col" onClick={resetSelectedLocations}>
                    <div className={`live-box ${isAllActive ? 'active' : ''}`}>
                        <span>{Translate.all}</span>
                    </div>
                </div>
                {locationsList}
            </div>
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Locations);
